import "../../sessions/redesign.css";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

const solutionLinks = [
  { to: "/solutions/attendance", label: "Attendance Management", desc: "Photo-verified check-ins across every device" },
  { to: "/solutions/leave", label: "Leave Management", desc: "Apply, approve and balance in one flow" },
  { to: "/solutions/activity-tracking", label: "Activity Tracking", desc: "See how teams spend their workday" },
  { to: "/solutions/timesheet", label: "Timesheet & Approval", desc: "Log hours, approve and report" },
  { to: "/solutions/visitor", label: "Visitor Management", desc: "Digital check-in for every guest" },
];

const RedesignNav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [solOpen, setSolOpen] = useState(false);
  const solRef = useRef(null);
  const solTimeout = useRef(null);
  const location = useLocation();
  const tokan = localStorage.getItem("tokan");
  const isActive = (path) => location.pathname === path;
  const isSolution = location.pathname.startsWith("/solutions/");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); setSolOpen(false); }, [location.pathname]);

  const handleSolEnter = () => { clearTimeout(solTimeout.current); setSolOpen(true); };
  const handleSolLeave = () => { solTimeout.current = setTimeout(() => setSolOpen(false), 180); };

  const handleSolKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setSolOpen(!solOpen); }
    if (e.key === "Escape") setSolOpen(false);
  };

  return (
    <nav className={`tt-nav ${scrolled ? "scrolled" : ""}`}>
      <div className="tt-nav__inner">
        <Link to="/" className="tt-nav__logo"><img src="/assets/logo3.svg" alt="TimeTango" /></Link>

        <div className={`tt-nav__links ${open ? "open" : ""}`}>
          <Link to="/" className={isActive("/") ? "active" : ""}>Features</Link>

          {/* Solutions dropdown */}
          <div
            className="tt-nav__dropdown-wrap"
            ref={solRef}
            onMouseEnter={handleSolEnter}
            onMouseLeave={handleSolLeave}
          >
            <button
              className={`tt-nav__dropdown-trigger ${isSolution || solOpen ? "active" : ""}`}
              onClick={() => setSolOpen(!solOpen)}
              onKeyDown={handleSolKeyDown}
              aria-expanded={solOpen}
              aria-haspopup="true"
            >
              Solutions
              <svg width="10" height="6" viewBox="0 0 10 6" style={{marginLeft:4,transition:"transform 0.2s",transform:solOpen?"rotate(180deg)":"none"}}>
                <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
              </svg>
            </button>
            {solOpen && (
              <div className="tt-nav__dropdown" role="menu">
                {solutionLinks.map((s) => (
                  <Link key={s.to} to={s.to} className="tt-nav__dropdown-item" role="menuitem" onClick={() => setSolOpen(false)}>
                    <span className="tt-nav__dropdown-label">{s.label}</span>
                    <span className="tt-nav__dropdown-desc">{s.desc}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link to="/pricing" className={isActive("/pricing") ? "active" : ""}>Pricing</Link>
          <Link to="/blogs" className={isActive("/blogs") ? "active" : ""}>Resources</Link>
          <Link to="/contact-us" className={isActive("/contact-us") ? "active" : ""}>Contact</Link>

          {/* Mobile-only: solutions expanded inline */}
          <div className="tt-nav__mobile-solutions">
            {solutionLinks.map((s) => (
              <Link key={s.to} to={s.to} className="tt-nav__mobile-sol-link">{s.label}</Link>
            ))}
          </div>
        </div>

        <div className="tt-nav__right">
          <Link to={tokan ? "/dashboard" : "/login"}>{tokan ? "Dashboard" : "Log in"}</Link>
          <Link to="/company-register" className="tt-btn tt-btn--grad tt-btn--pill" style={{padding:"9px 22px",fontSize:13}}>
            Start free trial
          </Link>
        </div>

        <button
          className={`tt-nav__toggle ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation menu"
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
};

export { solutionLinks };
export default RedesignNav;
